
import { supabase } from "@/integrations/supabase/client";

// Get user email from auth.users table or profiles table
export const getUserEmail = async (userId: string): Promise<string | null> => {
  try {
    console.log(`Getting email for user ${userId}`);
    
    if (!userId || userId.trim() === '') {
      console.error("Invalid user ID provided to getUserEmail:", userId);
      return null;
    }
    
    // First try to get the user's email from the current session if it's the current user
    const { data: sessionData } = await supabase.auth.getSession();
    if (sessionData.session?.user.id === userId && sessionData.session?.user.email) {
      console.log(`Using current user's email from session: ${sessionData.session.user.email}`);
      return sessionData.session.user.email;
    }
    
    // For other users, we need to get profile info and use a pseudo email
    // since we can't access other users' emails directly from the client
    const { data: profileData, error: profileError } = await supabase
      .from("profiles")
      .select("username, display_username") 
      .eq("id", userId)
      .single();
    
    if (profileError || !profileData) {
      console.error("Error fetching user profile:", profileError);
      return null;
    }
    
    // Create a pseudo email as a fallback
    const username = profileData.display_username || profileData.username;
    if (username) {
      // Check if username is already in email format
      if (typeof username === 'string' && username.includes('@')) {
        console.log(`Username appears to be an email: ${username}`);
        return username;
      }
      
      // Create a formatted email address for delivery
      // This is only used if we can't get the real email
      const formattedEmail = `${username.toString().replace(/\s+/g, '.')}@example.com`;
        
      console.log(`Could not find real email, using formatted email for delivery: ${formattedEmail}`);
      return formattedEmail;
    }
    
    console.error("Could not determine email for user");
    return null;
  } catch (error) {
    console.error("Exception in getUserEmail:", error);
    return null;
  }
};
